import React from "react";
import { ConnectProto } from "@racoon/api";
import { CreateShiftModal } from "../components/CreateShiftModal";
import type { ShiftData } from "../model/shift-data";

/** What a row needs to open the change-driver modal on its own shift. */
export type DriverChangeContext = {
  drivers: { id: string; name: string }[];
  defaultDate?: Date;
  onShiftChanged?: () => void;
};

/** The change-driver modal on a row's own shift, opened by `trigger`. */
export const ShiftDriverModal: React.FC<{
  row: ShiftData;
  truck: ConnectProto.Truck;
  change: DriverChangeContext;
  trigger: React.ReactElement;
}> = ({ row, truck, change, trigger }) => (
  <CreateShiftModal
    truckId={String(truck.id)}
    trucks={[truck]}
    drivers={change.drivers}
    activeDriverId={row.driverId != null ? String(row.driverId) : undefined}
    activeShiftId={row.id}
    activeShiftStatus={row.status}
    planStart={row.twStartAt}
    defaultDate={change.defaultDate}
    onShiftCreated={change.onShiftChanged}
    trigger={trigger}
  />
);
